import { render } from "./ElementSidebar.vue?vue&type=template&id=4861c692&scoped=true"
import script from "./ElementSidebar.vue?vue&type=script&lang=js"
export * from "./ElementSidebar.vue?vue&type=script&lang=js"

import "./ElementSidebar.vue?vue&type=style&index=0&id=4861c692&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4861c692"]])

export default __exports__